/**
 * 获取指定名称的 cookie 值
 * @param {string} name - cookie 的名称
 * @returns {string|null} - 返回 cookie 的值，如果未找到则返回 null
 */
export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}
